import React from 'react';
import './DmcaPolicy.scss';

const DmcaPolicy = () => {
  return (
    <div className="legal-page">
      <h1>DMCA Policy</h1>
      <div className="legal-content">
        <p>Last updated: {new Date().toLocaleDateString()}</p>

        <h2>Notification of Copyright Infringement</h2>
        <p>Audioread by Astrophe, LLC ("Audioread") respects the intellectual property rights of others and expects its users to do the same. In accordance with the Digital Millennium Copyright Act of 1998 ("DMCA"), we will respond expeditiously to claims of copyright infringement that are reported to our designated copyright agent.</p>

        <h2>DMCA Notice Requirements</h2>
        <p>If you are a copyright owner, or authorized to act on behalf of one, and you believe that your copyrighted work has been copied in a way that constitutes copyright infringement, please submit a written DMCA notice. In accordance with the DMCA, the written notice (the "DMCA Notice") must include substantially the following:</p>
        <ul>
          <li>Your physical or electronic signature</li>
          <li>Identification of the copyrighted work you believe to have been infringed</li>
          <li>Identification of the material you believe to be infringing in a sufficiently precise manner to allow us to locate that material</li>
          <li>Adequate information by which we can contact you (including your name, postal address, telephone number, and email address)</li>
          <li>A statement that you have a good faith belief that use of the copyrighted material is not authorized by the copyright owner, its agent, or the law</li>
          <li>A statement that the information in the written notice is accurate</li>
          <li>A statement, under penalty of perjury, that you are authorized to act on behalf of the copyright owner</li>
        </ul>

        <h2>Where to Send Notices</h2>
        <p>Please send DMCA notices to our designated copyright agent at:</p>
        <p>
          DMCA Agent: Ryan Walter<br />
          Audioread by Astrophe, LLC<br />
          8 The Green, Suite 300<br />
          Dover, DE 19901<br />
          Email: ryan@audioread.com<br />
          Phone: +1 (951) 666-3443
        </p>

        <h2>Counter-Notification</h2>
        <p>If you believe that your content that was removed is not infringing, or that you have the authorization to post and use that content from the copyright owner, the copyright owner's agent, or pursuant to the law, you may send a counter-notice containing the following information to our copyright agent:</p>
        <ul>
          <li>Your physical or electronic signature</li>
          <li>Identification of the content that has been removed and the location at which the content appeared before it was removed</li>
          <li>A statement that you have a good faith belief that the content was removed as a result of mistake or misidentification</li>
          <li>Your name, address, telephone number, and email address</li>
          <li>A statement that you consent to the jurisdiction of the federal court in Delaware</li>
          <li>A statement that you will accept service of process from the person who provided notification of the alleged infringement</li>
        </ul>

        <h2>Repeat Infringers</h2>
        <p>It is our policy in appropriate circumstances to disable and/or terminate the accounts of users who are repeat infringers.</p>

        <h2>Changes to This Policy</h2>
        <p>We reserve the right to update or modify this DMCA Policy at any time and from time to time without prior notice. Please review this policy periodically, and especially before you provide any information. Your continued use of the Service after any modifications to this DMCA Policy will constitute your acceptance of such modifications.</p>

        <h2>Questions</h2>
        <p>If you have any questions about this DMCA Policy, please contact us at:</p>
        <p>
          Audioread by Astrophe, LLC<br />
          8 The Green, Suite 300<br />
          Dover, DE 19901<br />
          Email: ryan@audioread.com<br />
          Phone: +1 (951) 666-3443
        </p>
      </div>
    </div>
  );
};

export default DmcaPolicy; 